import { SxProps } from '@mui/material';

// Style to hide a tab but preserve its offsetWidth
// `display: none;` would not render the tab at all, hence offsetWidth = 0
// `visibility: hidden;` alone would make the tab invisible but still take space
export const HIDDEN_TAB_STYLES: SxProps = { '&.hidden': { visibility: 'hidden', position: 'absolute', left: '-10000px' } };
